/* ============================================
   YUNGMAA — interactions
   ============================================ */

(function () {
  'use strict';

  // -------------------------------
  // Custom cursor (postmark style)
  // -------------------------------
  const dot  = document.querySelector('.cursor-dot');
  const ring = document.querySelector('.cursor-ring');
  if (dot && ring && window.matchMedia('(hover: hover)').matches) {
    let mx = window.innerWidth / 2, my = window.innerHeight / 2;
    let rx = mx, ry = my;

    window.addEventListener('mousemove', (e) => {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = `translate(${mx}px, ${my}px) translate(-50%, -50%)`;
    });

    const loop = () => {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      ring.style.transform = `translate(${rx}px, ${ry}px) translate(-50%, -50%)`;
      requestAnimationFrame(loop);
    };
    loop();

    document.querySelectorAll('a, button, .product, .hero-card, .wall-stamp').forEach(el => {
      el.addEventListener('mouseenter', () => document.body.classList.add('cursor-hover'));
      el.addEventListener('mouseleave', () => document.body.classList.remove('cursor-hover'));
    });
  }

  // -------------------------------
  // Floating stamps parallax (hero)
  // -------------------------------
  const stamps = document.querySelectorAll('.stamp-float');
  if (stamps.length && window.matchMedia('(hover: hover)').matches) {
    const hero = document.querySelector('.hero');
    if (hero) {
      hero.addEventListener('mousemove', (e) => {
        const rect = hero.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width  - 0.5;
        const y = (e.clientY - rect.top)  / rect.height - 0.5;
        stamps.forEach((s) => {
          const depth = parseFloat(s.dataset.depth || 1);
          const rot   = parseFloat(s.dataset.rot   || 0);
          const tx = x * depth * -40;
          const ty = y * depth * -40;
          s.style.transform = `translate(${tx}px, ${ty}px) rotate(${rot}deg)`;
        });
      });
      hero.addEventListener('mouseleave', () => {
        stamps.forEach((s) => {
          const rot = parseFloat(s.dataset.rot || 0);
          s.style.transform = `translate(0,0) rotate(${rot}deg)`;
        });
      });
    }
  }

  // -------------------------------
  // 3D tilt on hero card
  // -------------------------------
  const tiltCard = document.querySelector('.hero-card');
  if (tiltCard && window.matchMedia('(hover: hover)').matches) {
    tiltCard.addEventListener('mousemove', (e) => {
      const r = tiltCard.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width  - 0.5) * 2;
      const y = ((e.clientY - r.top)  / r.height - 0.5) * 2;
      tiltCard.style.transform = `perspective(1100px) rotateY(${x * 6}deg) rotateX(${-y * 6}deg) translateZ(0)`;
    });
    tiltCard.addEventListener('mouseleave', () => {
      tiltCard.style.transform = 'perspective(1100px) rotateY(0) rotateX(0)';
    });
  }

  // -------------------------------
  // Magnetic buttons
  // -------------------------------
  document.querySelectorAll('[data-magnetic]').forEach((btn) => {
    btn.addEventListener('mousemove', (e) => {
      const r = btn.getBoundingClientRect();
      const x = e.clientX - r.left - r.width / 2;
      const y = e.clientY - r.top  - r.height / 2;
      btn.style.transform = `translate(${x * 0.15}px, ${y * 0.25}px)`;
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transform = 'translate(0,0)';
    });
  });

  // -------------------------------
  // Scroll reveals
  // -------------------------------
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('in-view'), i * 80);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.product, [data-reveal]').forEach(el => io.observe(el));
  }

  // -------------------------------
  // Sticky header shrink
  // -------------------------------
  const header = document.querySelector('.site-header');
  if (header) {
    let lastY = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('scrolled', y > 30);
      if (y > 120 && y > lastY) header.classList.add('hide');
      else header.classList.remove('hide');
      lastY = y;
    }, { passive: true });
  }

  // -------------------------------
  // Stamp wall gentle drift (mood board)
  // -------------------------------
  const wallStamps = document.querySelectorAll('.wall-stamp');
  if (wallStamps.length && window.matchMedia('(hover: hover)').matches) {
    const wall = document.querySelector('.collection-wall');
    if (wall) {
      wall.addEventListener('mousemove', (e) => {
        const r = wall.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width  - 0.5;
        const y = (e.clientY - r.top)  / r.height - 0.5;
        wallStamps.forEach((s, i) => {
          const depth = (i % 4 + 1) * 6;
          const baseRot = parseFloat(s.dataset.baseRot || 0);
          s.style.transform = `translate(${x * depth}px, ${y * depth}px) rotate(${baseRot}deg)`;
        });
      });
    }
  }
})();

/* ============================================
   V3 — LOADER · SCRAMBLE · HAMBURGER · ENHANCEMENTS
   ============================================ */

// ── Loader ──────────────────────────────────
(function () {
  const loader = document.getElementById('loader');
  if (!loader) return;
  const hide = () => loader.classList.add('loaded');
  if (document.readyState === 'complete') {
    setTimeout(hide, 2400);
  } else {
    window.addEventListener('load', () => setTimeout(hide, 2400));
  }
})();

// ── Text Scramble ────────────────────────────
(function () {
  const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789█▓▒░';

  function scramble(el) {
    const target = el.dataset.text || el.textContent.trim();
    let frame = 0;
    let rafId;
    const queue = target.split('').map((to, i) => ({
      to,
      start: Math.floor(i * 1.5),
      end:   Math.floor(i * 1.5) + 10 + Math.floor(Math.random() * 12),
      char: ''
    }));

    function tick() {
      let out = '';
      let done = 0;
      queue.forEach(item => {
        if (frame >= item.end) {
          done++;
          out += item.to;
        } else if (frame >= item.start) {
          if (!item.char || Math.random() < 0.3) {
            item.char = CHARS[Math.floor(Math.random() * CHARS.length)];
          }
          out += `<span class="scramble-char">${item.char}</span>`;
        } else {
          out += '<span style="opacity:0">_</span>';
        }
      });
      el.innerHTML = out;
      if (done < queue.length) {
        frame++;
        rafId = requestAnimationFrame(tick);
      } else {
        el.textContent = target;
      }
    }

    cancelAnimationFrame(rafId);
    frame = 0;
    tick();
  }

  const targets = document.querySelectorAll('[data-scramble]');
  targets.forEach(el => {
    setTimeout(() => scramble(el), 2600);
  });
})();

// ── Hamburger / Mobile Nav ───────────────────
(function () {
  const btn     = document.getElementById('hamburger');
  const overlay = document.getElementById('nav-overlay');
  if (!btn || !overlay) return;

  btn.addEventListener('click', () => {
    const open = btn.classList.toggle('open');
    overlay.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', String(open));
    overlay.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
  });

  overlay.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => {
      btn.classList.remove('open');
      overlay.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('open')) {
      btn.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  });
})();

// ── Quick-Add hover reveal ───────────────────
(function () {
  document.querySelectorAll('.product-quick-add').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => {
          btn.textContent = 'Ajouté ✓';
          const count = document.querySelector('.cart-count');
          if (count) {
            const n = parseInt(count.textContent.replace(/\D/g, '')) + 1;
            count.textContent = `(${n})`;
          }
          setTimeout(() => (btn.textContent = 'QUICK ADD'), 2000);
        })
        .catch(() => (btn.textContent = 'QUICK ADD'));
    });
  });
})();

// ── Cursor: add archive tiles to hover set ───
(function () {
  document.querySelectorAll('.archive-tile, [data-reveal]').forEach(el => {
    el.addEventListener('mouseenter', () => document.body.classList.add('cursor-hover'));
    el.addEventListener('mouseleave', () => document.body.classList.remove('cursor-hover'));
  });
})();
